import { makeLMStyles } from "@launchmetrics/lm-ui";


export const useStyles = makeLMStyles(() => ({
	reportManager: {
		backgroundColor: '#f6f3f3',
		height: '100%',
		paddingTop: 'spacing-32'
	},
	reportManagerMainHeader: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	reportManagerTableContainer: {
		display: 'flex',
		flexDirection: 'column',
		padding: 'spacing-24',
		backgroundColor: 'white',
		borderRadius: 'radius8'
	},
	reportManagerPaginationContainer: {
		backgroundColor: 'white',
		marginTop: 'spacing-24',
		paddingTop: 'spacing-24',
		paddingBottom: 'spacing-24'
	},
	totalReports: {
		paddingBottom: 'spacing-16',
		fontWeight: 'semibold'
	},
	tableHeaders: {
		fontWeight: 'bold'
	}
}));
